import { jsx as _jsx } from "react/jsx-runtime";
import { TaskTemplateMultiSelect } from '../multiselect/TaskTemplateMultiSelect';
export const FilterTaskTemplateMultiSelect = ({ item, clearItems, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    var _a;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(TaskTemplateMultiSelect, { selection: (_a = activeFilters[item]) !== null && _a !== void 0 ? _a : [], onChange: value => setFilter((clearItems && (!value || value.length !== 1)
                ? Object.assign({ [item]: value !== null && value !== void 0 ? value : [] }, clearItems.reduce((prev, clearItem) => (Object.assign(Object.assign({}, prev), { [clearItem]: undefined })), {})) : { [item]: value !== null && value !== void 0 ? value : [] })), placeholder: undefined })),
    });
};
